import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100vh',
    marginTop: -theme.spacing(4),
    marginLeft: theme.spacing(-3),
    marginRight: theme.spacing(-3),
    [theme.breakpoints.down('xs')]: {
      marginTop: -theme.spacing(3),
      marginLeft: theme.spacing(-2),
      marginRight: theme.spacing(-2),
    },
  },
  hero: {
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(6, 0),
  },
  heroInner: {
    maxWidth: 1280,
    margin: '0 auto',
    padding: theme.spacing(0, 3),
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(4),
    },
  },
  heroLeft: {
    flex: 1,
    minWidth: 0,
    paddingTop: theme.spacing(1),
  },
  congratsTitle: {
    fontSize: 32,
    fontWeight: 700,
    color: theme.palette.primary.contrastText,
    marginBottom: theme.spacing(1.5),
    lineHeight: 1.2,
  },
  failTitle: {
    fontSize: 28,
    fontWeight: 700,
    color: theme.palette.primary.contrastText,
    marginBottom: theme.spacing(1.5),
    lineHeight: 1.2,
  },
  heroSubtitle: {
    fontSize: 15,
    color: theme.palette.primary.contrastText,
    opacity: 0.88,
    lineHeight: 1.7,
    marginBottom: theme.spacing(4),
  },
  downloadButton: {
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.dark,
    border: `2px solid ${theme.palette.secondary.dark}`,
    fontWeight: 700,
    fontSize: 14,
    borderRadius: 10,
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.primary.contrastText,
      opacity: 0.9,
    },
  },
  heroRight: {
    flexShrink: 0,
    width: 340,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  certificateLabel: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    textAlign: 'center',
    pointerEvents: 'none',
    textShadow: '0 1px 4px rgba(0,0,0,0.4)',
    width: '80%',
  },
  certificatePreview: {
    width: '100%',
    borderRadius: 12,
    boxShadow: theme.shadows[8],
    display: 'block',
  },
  body: {
    maxWidth: 1280,
    margin: '0 auto',
    padding: theme.spacing(5, 3),
    display: 'flex',
    gap: theme.spacing(6),
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(4),
    },
  },
  detailsSection: {
    flex: 1,
    minWidth: 0,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 10,
    padding: theme.spacing(0, 2.5),
  },
  detailRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: theme.spacing(2),
    padding: theme.spacing(1.75, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  detailLabel: {
    fontSize: 14,
    fontWeight: 700,
    color: theme.palette.common.black,
    minWidth: 140,
    flexShrink: 0,
  },
  detailValue: {
    fontSize: 14,
    color: theme.palette.primary.black,
    fontWeight: 400,
  },
  storageBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    width: 340,
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  storageIconBox: {
    width: 64,
    height: 64,
    borderRadius: 12,
    backgroundColor: theme.palette.action.hover,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  storageIcon: {
    color: theme.palette.text.disabled,
  },
  storageTitle: {
    fontSize: 15,
    fontWeight: 700,
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  storageSubtitle: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    textAlign: 'center',
    lineHeight: 1.6,
  },
  navigation: {
    maxWidth: 1280,
    margin: '0 auto',
    padding: theme.spacing(0, 3, 4),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(3),
  },
  prevButton: {
    color: theme.palette.text.secondary,
    borderColor: theme.palette.divider,
    textTransform: 'none',
    fontWeight: 500,
  },
  homeButton: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    padding: theme.spacing(0.5, 3),
    '&:hover': {
      backgroundColor: theme.palette.common.black,
      opacity: 0.8,
    },
  },
  downloadFeedback: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  downloadFeedbackText: {
    marginLeft: theme.spacing(1),
    fontSize: 14,
    color: theme.palette.primary.contrastText,
  },
}))

export default useStyles
